define(
    'views/awards.view',[
        'loader',
        'config',
        'helper',
        'sandbox',

        'text!templates/awards_link.html',
        'text!templates/ajax_loader.html',
        'text!templates/awards_list_content.html',
        'text!templates/awards_list_content_item.html',
        'text!templates/awards_user_content.html',
        'text!templates/awards_user_content_item.html',
        'text!templates/awards_cur_user_content.html',
        'text!templates/awards_cur_user_content_item.html',
        'text!templates/awards-profile-menu.html',
        'text!templates/awards-profile-link.html',
        'text!templates/awards-profile.html',
        'text!templates/awards-profile-item.html',
        'text!templates/prepare_topic_awards.html',
        'text!templates/topic_awards_profile_content.html'
    ],
    function(
        Loader,
        Config,
        Helper,
        Sandbox,
        awardsLinkTemplate,
        ajaxLoaderTemplate,
        listContentTemplate,
        listContentItemTemplate,
        userContentTemplate,
        userContentItemTemplate,
        curUserContentTemplate,
        curUserContentItemTemplate,
        templateProfileMenu,
        templateProfileLink,
        templateProfileContent,
        templateProfileItemContent,
        prepareTopicAwardsContent,
        topicAwardsProfileContent)
    {
        var $ = Loader.$;
        var _ = Loader._;

        var AwardsView = Loader.Backbone.View.extend(
            {
                isActive: false,
                items: [],
                profileItems: [],
                allItems: [],
                settings: [],
                editFormShowed: false,
                limit: 50,
                offset: 0,
                loadInProcess: false,
                searchName: '',

                events: {
                    'click .deleteAwardBtn': 'deleteAward',
                    'click #award-send': 'sendAward',
                    'click .award-button-toggle-description': 'editDescription',
                    'click .award-button-edit-description': 'saveDescription',
                    'click #load-more-awards': 'loadMore',
                    'click .js-select-award': 'selectAward',
                    'keyup input[name="search_award"]': 'searchAwards'
                },

                routes: {
                    "*": "insertLink",
                    "/mod/awards": "renderAwards",
                    'profile.php[?]section=fields[&]id=(.*)[&]p=awards': 'renderProfileAwards',
                    'profile.php': 'profileMenu profileLink',
                    "/viewtopic.php": 'awardsInTopic'
                },

                initialize: function()
                {
                    var _this = this;
                    _.bindAll(this, 'render');

                    this.model.on('startApplication', function(){
                        Config.modules.awards.enabled && Helper.filterRoutes(_this.routes, _this);
                    });
                },

                render: function()
                {
                    return this;
                },

                insertLink: function()
                {

                    var compiledTemplate = _.template(
                        awardsLinkTemplate,
                        {
                            model: this.model.toJSON(),
                            Config: Config
                        }
                    );

                    if (Config.modules.awards.menuLink) {
                        if( $('#navrules').length > 0 ) {
                            $('#navrules')
                                .before(compiledTemplate);
                        } else if( $('#navuserlist').length > 0 ) {
                            $('#navuserlist')
                                .after(compiledTemplate);
                        } else {
                            $('#navindex')
                                .after(compiledTemplate);
                        }
                    }
                },

                renderAwards: function()
                {
                    var _this = this;

                    if (!Helper.getParam('uid')) {
                        this.model.get('breadcrumbs').setCrumbs({
                            '': Config.modules.awards.title
                        });
                    }

                    var breadCrumbsRendered = false;

                    var template = "";
                    var sortMod  = Helper.getParam('sort') || Config.modules.awards.board_award_sort;
                    var className = 'mod-awards-users';

                    if (Helper.getParam('uid') > 0) {
                        template = curUserContentTemplate;
                        className = 'mod-awards-user';
                    } else if (sortMod == 'list') {
                        template = listContentTemplate;
                        className = 'mod-awards-list';
                    } else {
                        template = userContentTemplate;
                    }

                    $('#pun-mod')
                        .addClass('mod-awards')
                        .addClass(className);

                    var compiledTemplate = _.template(
                        template,
                        {
                            model: _this.model.toJSON(),
                            awards: [],
                            Config: Config,
                            Helper: Helper
                        }
                    );

                    _this.$el.html(compiledTemplate);
                    this.ajaxLoader();

                    this.getAwards({}, function(data){
                        if (data[0] && !breadCrumbsRendered && Helper.getParam('uid') > 0) {
                            _this.model.get('breadcrumbs').setCrumbs({
                                '/mod/awards/': Config.modules.awards.title,
                                '': Config.modules.awards.userAwardsTitle.replace('{username}', data[0].user_login)
                            });
                            breadCrumbsRendered = true;
                        }

                        this.renderAwardsItems(data);
                    }.bind(this));
                },

                searchAwards: _.debounce(function() {
                    const inputText = this.$('input[name="search_award"]').val();
                    this.$el.find('#load-more-awards').show();
                    this.searchName = inputText;
                    this.offset = 0;
                    this.getAwards({
                            sort: "list",
                            name: inputText,
                        },
                        function(awards){
                            awards = _.sortBy(awards, function(item){return +item.id});
                            this.renderProfileSendItems(awards);
                        }.bind(this)
                    );
                }, 500),

                getAwards: function (data, callback, silent) {
                    if (!data) data = {};
                    if (!data.limit) data.limit = this.limit;
                    if (!data.offset) data.offset = this.offset;
                    this.model.get('awards').getAwards(data, function(data){
                        callback(data);
                    }.bind(this), silent);
                },

                renderAwardsItems: function (items, append, showNoAwards) {
                    if (typeof showNoAwards == 'undefined') showNoAwards = true;
                    var template = "";
                    var sortMod  = Helper.getParam('sort') || Config.modules.awards.board_award_sort;

                    if (Helper.getParam('uid') > 0) {
                        template = curUserContentItemTemplate;
                    } else if (sortMod == 'list') {
                        template = listContentItemTemplate;
                    } else {
                        template = userContentItemTemplate;
                    }

                    var compiledTemplate = _.template(
                        template,
                        {
                            model: this.model.toJSON(),
                            awards: items,
                            showNoAwards: showNoAwards,
                            Config: Config,
                            Helper: Helper
                        }
                    );

                    if (!append)
                        this.$el.find("#awards-content").html(compiledTemplate);
                    else
                        this.$el.find("#awards-content").append(compiledTemplate);

                    if ((Helper.getParam('uid') > 0 && items[0] && items[0].awards.length < this.limit) || items.length < this.limit)
                        this.$el.find('#load-more-awards').hide();
                },

                loadMore: function () {
                    var isProfile = location.href.indexOf('/profile.php?') != -1;
                    if (this.loadInProcess) return;
                    this.loadInProcess = true;
                    this.offset+=this.limit;
                    this.$el.find('#load-more-awards').html('Загружаю...');
                    var request = {limit: this.limit, offset: this.offset, name: this.searchName};
                    if (isProfile) request.sort = 'list';
                    this.getAwards(request, function(items) {
                        if (location.href.indexOf('/profile.php?') != -1)
                            this.renderProfileSendItems(items, true, false);
                        else
                            this.renderAwardsItems(items, true, false);
                        this.loadInProcess = false;
                        this.$el.find('#load-more-awards').html('Показать еще');
                        if (items.length < this.limit)
                            this.$el.find('#load-more-awards').hide();
                    }.bind(this), true);
                },

                ajaxLoader: function()
                {
                    this.$el.find("#awards-content")
                        .css({"visibility":"visible"})
                        .html(ajaxLoaderTemplate);
                },

                renderProfileAwards: function()
                {
                    if (!Config.modules.awards.enabled) return;
                    this.isActive = true;
                    var user = this.model.get('users').getMe();

                    var profileHtml = $('#profile8').html();

                    $('#profile').html('<div class="container">'+profileHtml+'</div>');
                    $('#profile .container fieldset, #profile .container p').remove('');
                    $("#profile .container").append('<div id="profileContainer" class="profile-awards-container"></div>');

                    this.renderProfileContent();

                    this.getAwards({
                        sort: "user",
                        users_ids: [Helper.getParam('id')]
                    }, function(data){
                        //this.renderProfileUserAwards(data);
                        this.profileItems = data;
                        this.renderProfileContent();

                        if (this.canSend()) {
                            this.getAwards({
                                    sort: "list",
                                    include: [],
                                },
                                function(awards){
                                    // awards = _.sortBy(awards, function(item){return +item.id});
                                    this.renderProfileSendItems(awards);
                                }.bind(this)
                            );
                        }
                    }.bind(this), true);
                },

                renderProfileSendItems: function(items, append, showNoAwards)
                {
                    if (typeof showNoAwards == 'undefined') showNoAwards = true;

                    var compiledTemplate = _.template(
                        templateProfileItemContent,
                        {
                            model: this.model.toJSON(),
                            awards: items,
                            showNoAwards: showNoAwards,
                            Config: Config,
                            Helper: Helper
                        }
                    );

                    if (!append)
                        this.$el.find("#awards-content").html(compiledTemplate);
                    else
                        this.$el.find("#awards-content").append(compiledTemplate);

                    if (items.length < this.limit)
                        this.$el.find('#load-more-awards').hide();


                },

                renderProfileContent: function()
                {
                    if (!Config.modules.awards.enabled) return;

                    var user = this.model.get('users').getMe();

                    var compiledTemplate = _.template(
                        templateProfileContent,
                        {
                            model: this.model.toJSON(),
                            user: user.toJSON(),
                            canEdit: this.canEdit.bind(this),
                            canSend: this.canSend.bind(this),
                            showSearch: this.showSearch,
                            awards: this.allItems,
                            result: this.profileItems,
                            settings: this.settings,
                            Config: Config,
                            Helper: Helper
                        }
                    );
                    $('#profileContainer').html(compiledTemplate);
                },

                selectAward: function (e) {
                    var $btn = $(e.currentTarget),
                        id = $btn.attr('data-id');
                    if (!id) return;

                    $('#profileContainer .next-step').show();
                    $('#profileContainer input[name=award]').val(id);

                },

                profileMenu: function()
                {
                    if (!Config.modules.awards.enabled) return;
                    if ($('#profile-right').length) return;

                    var compiledTemplate = _.template(
                        templateProfileMenu,
                        {
                            model: this.model.toJSON(),
                            userId: Helper.getParam('id'),
                            Config: Config,
                            Helper: Helper,
                            isActive: this.isActive
                        }
                    );

	                if (this.isActive) {
		                $('#profilenav ul li.isactive').removeClass('isactive');
	                }
                    $('#profilenav ul').append(compiledTemplate);
                },

                profileLink: function()
                {
                    var _this = this;
                    if (!Config.modules.awards.enabled) return;

                    if (!$('#profile-right').length) return;

                    this.model.get('awards').getAwards({
                        sort: "user",
                        users_ids: [Helper.getParam('id')]
                    }, _.once(function(data){
                        var compiledTemplate = _.template(
                            templateProfileLink,
                            {
                                model: _this.model.toJSON(),
                                userId: Helper.getParam('id'),
                                awardsCount: data[0].awards.length,
                                Config: Config,
                                Helper: Helper
                            }
                        );
                        $('#profile-right').append(compiledTemplate);
                    }));
                },

                deleteAward: function(e)
                {
                    if (!Config.modules.awards.enabled) return;

                    var awardId = $(e.currentTarget).attr('data-id');

                    if (!awardId) return false;

                    this.model.get('awards').deleteAward(awardId, function(data){
                        if (data.status == 'success')
                            location.reload();
                        else
                            alert('Произошла ошибка при удалении награды');
                    }, function(){
                        alert('Произошла ошибка при удалении награды');
                    });
                },

                sendAward: function(e)
                {
                    if (!Config.modules.awards.enabled) return;

                    var userId = Helper.getParam('id');

                    if (!userId) return false;

                    var awardId = $('#award-id').val();

                    if(awardId == 0) {
                        alert('Не выбрана награда');
                        return false;
                    }
                    var description = $('#award-description').val();

                    this.model.get('awards').sendAward({
                        awardId: awardId,
                        description: description
                    }, function(data){
                        if (data.status == 'success')
                            location.reload();
                        else
                            alert('Произошла ошибка при вручении награды');
                    }, function(){
                        alert('Произошла ошибка при вручении награды');
                    });
                },

                editDescription: function(e)
                {
                    if (!Config.modules.awards.enabled) return;

                    var awardId = $(e.currentTarget).attr('data-id');

                    $('.award-description[data-id='+awardId+']').hide();
                    $('.award-field-description[data-id='+awardId+']').show();
                },

                saveDescription: function(e)
                {
                    if (!Config.modules.awards.enabled) return;

                    var awardId = $(e.currentTarget).attr('data-id');

                    this.model.get('awards').editDescription({
                        id: awardId,
                        description: $('.award-field-description[data-id='+awardId+']').find('textarea').val()
                    }, function(data){
                        if (data.status == 'success')
                            location.reload();
                        else
                            alert('Произошла ошибка при редактировании награды');
                    }, function(){
                        alert('Произошла ошибка при редактировании награды');
                    });
                },

                canEdit: function(){
                    var user = this.model.get('users').getMe();
                    if (user.get('id') == Helper.getParam('id')) return true;
                    else if (user.isAdmin()) return true;
                    else if (user.isModerator() && Config.modules.awards.moderatorsAccess) {
                        return true;
                    }
                    return false;
                },

                canSend: function(){
                    var user = this.model.get('users').getMe();
                    if (user.isAdmin()) return true;
                    else if (user.isModerator() && Config.modules.awards.moderatorsAccess) {
                        return true;
                    }
                    return false;
                },

                awardsInTopic: function()
                {
                    if (!Config.modules.awards.enabled) return;
                    if (!Config.modules.awards.showInPost) return;
                    var user = this.model.get('users').getMe();
                    var self = this;
                    var users = [];

                    $('div.post').each(function(){
                        var userId = 1;

                        if (!user.isGuest()) {
                            $('li.pl-email a', this).each(function(){
                                if ($(this).html().indexOf('Профиль') != -1) {
                                    var href = $(this).attr("href");
                                    userId = href.substring(href.indexOf("profile.php?id=")+15, href.length);
                                }
                            });
                        }
                        else {
                            $('li.pa-author a', this).each(function() {
                                var href = $(this).attr("href");
                                userId = href.substring(href.indexOf("profile.php?id=")+15, href.length);
                            });
                        }

                        if (userId > 1) {
                            users.push(userId);
                            var compiledTemplate = _.template(
                                prepareTopicAwardsContent,
                                {
                                    model: self.model.toJSON(),
                                    Helper: Helper,
                                    Config: Config,
                                    userId: userId
                                }
                            );

                            if (Config.modules.awards.detail) {
                                $('.post-author ul:first', this).append(compiledTemplate);
                            }
                            else {
                                if( $('.post-author ul:first li.pa-positive', this).length == 0 )
                                    $('.post-author ul:first', this).append(compiledTemplate);
                                else
                                    $('.post-author ul:first li.pa-positive', this).after(compiledTemplate);
                            }
                        }

                    });

                    users = _.uniq(users);

                    if (users.length) {
                        this.model.get('awards').getAwards({
                            sort: "user",
                            users_ids: users
                        }, function(data){

                            _.each(users, function(userId){
                                var val = _.find(data, function(val){return val.user_id == userId});
                                var awards = val && val.awards || [];

                                if (Config.modules.awards.detail) {
                                    var compiledTemplate = _.template(
                                        topicAwardsProfileContent,
                                        {
                                            model: self.model.toJSON(),
                                            Helper: Helper,
                                            Config: Config,
                                            userId: userId,
                                            awards: awards
                                        }
                                    );

                                    $('.pa-awards[data-id='+userId+'] .mini_awards').html(compiledTemplate);

                                    if (!awards.length && !Config.modules.awards.showWithoutAwards) {
                                        $('.pa-awards[data-id='+userId+']').empty();
                                    }
                                }
                                else {
                                    $('.pa-awards[data-id='+userId+'] span').html(awards.length);
                                }
                            });

                            /*_.each(data, function(val){
                                if (Config.modules.awards.detail) {
                                    var compiledTemplate = _.template(
                                        topicAwardsProfileContent,
                                        {
                                            model: self.model.toJSON(),
                                            Helper: Helper,
                                            Config: Config,
                                            userId: val.user_id,
                                            awards: val.awards
                                        }
                                    );
                                    $('.pa-awards[data-id='+val.user_id+'] .mini_awards').html(compiledTemplate);
                                }
                                else {
                                    $('.pa-awards[data-id='+val.user_id+'] span').html(val.awards.length);
                                }
                            });*/
                        },
                        true);

                        $('.mini_awards img[title]').tipsy({fade: true, gravity: 's'});
                    }
                }
            });

        return {
            initialize: function(model)
            {
                return new AwardsView({
                    el: $("#pun-main"),
                    model: model
                })
            }
        }
    }
);

